import { cn } from '@/lib/utils';

/** The spinning ring shown while something loads. */
export default function ClassicLoader({ className, size = 40 }: { className?: string; size?: number }) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn('flex animate-spin items-center justify-center rounded-full border-4 border-primary border-t-transparent', className)}
      style={{ width: size, height: size }}
    />
  );
}

/** The lighter variant: two arcs on a thin ring. */
export function ModifiedClassicLoader({ className, size = 40 }: { className?: string; size?: number }) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn('animate-spin rounded-full border-b-2 border-t-2 border-primary ease-linear', className)}
      style={{ width: size, height: size }}
    />
  );
}

/** A page-sized loading state: the ring, centred, with room around it. */
export function PageLoader({ className, label }: { className?: string; label?: string }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 py-16', className)}>
      <ClassicLoader />
      {label && <p className="text-sm text-muted-foreground">{label}</p>}
    </div>
  );
}
